<template src="./settingsidebar.html"></template>

<script>
  export default {
    name: 'SettingSidebar',
    props: {
      active_tab: { type: String, default: null }
    },
    data () {
      return {
        selectedPage: this.active_tab || 'account'
      }
    },
    computed: {
      menuItems () {
        const items = []
        if (this.$store.getters['user/isAuthenticated'] && !this.$store.getters['user/isPlatformAdmin']) {
          items.push({ tab: 'account', label: 'Account', name: 'AccountSettings' })
          items.push({ tab: 'display', label: 'Display', name: 'DisplaySettings' })
        }
        if (this.$store.getters['user/isCatalogEditor']) {
          items.push({ tab: 'category', label: 'Category', name: 'CategorySettings' })
        }
        if (this.$store.getters['user/isAuthenticated']) {
          items.push({ tab: 'material', label: 'Products', name: 'MaterialSettings' })
        }
        items.push({ tab: 'task', label: 'Tasks', name: 'TaskSettings' })
        return items
      },
      /** Format for app-select: array of { id, name } */
      selectItems () {
        return this.menuItems.map(m => ({ id: m.tab, name: m.label }))
      }
    },
    watch: {
      active_tab (val) {
        const tab = val || 'account'
        const hasTab = this.menuItems.some(i => i.tab === tab)
        this.selectedPage = hasTab ? tab : (this.menuItems[0] ? this.menuItems[0].tab : 'account')
      },
      menuItems: {
        immediate: true,
        handler (items) {
          if (items.length && !items.some(i => i.tab === this.selectedPage)) {
            this.selectedPage = items[0].tab
          }
        }
      }
    },
    methods: {
      onPageChange (tab) {
        const item = this.menuItems.find(i => i.tab === tab)
        if (item && this.$route.name !== item.name) {
          this.$router.push({ name: item.name })
        }
      }
    }
  }
</script>

<style scoped>
  .settings-side-menu-dropdown {
    width: 100%;
    margin-bottom: 1rem;
  }
  .settings-side-menu-dropdown label {
    display: block;
    margin-bottom: 0.5rem;
    color: var(--color-text);
    font-weight: 400;
  }
</style>
